var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TreeSelect',_vm._g(_vm._b({ref:"treeSelect",staticStyle:{"width":"100%"},attrs:{"apiUrl":_vm.apiUrl,"apiData":_vm.apiData,"clearable":"","multiple":_vm.multiple,"returnType":"xx"},on:{"setSearchModal":_vm.setSearchModalHandler}},'TreeSelect',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }